export const workspaceMappings = {
  '/mirror': {
    title: 'Mirror Configuration',
    secondaryButtons: [
      {
        id: 'source-scanner',
        label: 'Domain Scan',
        path: '/mirror/source',
        workspace: 'SourceScanner',
      },
      {
        id: 'site-overview',
        label: 'Site Overview',
        path: '/mirror/site',
        workspace: 'SiteOverview',
      },
      {
        id: 'template-factory',
        label: 'Template Factory',
        path: '/mirror/factory',
        workspace: 'TemplateFactory',
      },
      {
        id: 'menu-editor',
        label: 'Menu Editor',
        path: '/mirror/navigation',
        workspace: 'MenuEditor',
      },
      {
        id: 'page-structure',
        label: 'Page Structure',
        path: '/mirror/structure',
        workspace: 'PageStructureEditor',
      },
      {
        id: 'site-metadata',
        label: 'Metadata & Assets',
        path: '/mirror/metadata',
        workspace: 'SiteMetadataEditor',
      },
      {
        id: 'preview-compare',
        label: 'Preview Compare',
        path: '/mirror/preview',
        workspace: 'PreviewCompare',
      },
      {
        id: 'publish-center',
        label: 'Publish Center',
        path: '/mirror/publish',
        workspace: 'PublishCenter',
      },
      {
        id: 'version-history',
        label: 'Version History',
        path: '/mirror/history',
        workspace: 'VersionHistory',
      },
      {
        id: 'migration-center',
        label: 'Migration Center',
        path: '/mirror/migration',
        workspace: 'MigrationCenter',
      },
      {
        id: 'element-surgery',
        label: 'Visual Editor',
        path: '/mirror/editor',
        workspace: 'ElementSurgery',
      },
    ],
  },
  '/content': {
    title: 'Content Factory',
    secondaryButtons: [
      {
        id: 'content-publish',
        label: 'Publish Center',
        path: '/content/publish',
        workspace: 'ArticleEditor',
      },
      {
        id: 'route-manager',
        label: 'Route Manager',
        path: '/content/routes',
        workspace: 'RouteManager',
      },
    ],
  },
  '/analytics': {
    title: 'Analytics',
    secondaryButtons: [
      {
        id: 'heatmap',
        label: 'Heatmap',
        path: '/analytics/heatmap',
        workspace: 'Heatmap',
      },
      {
        id: 'timeline',
        label: 'Timeline',
        path: '/analytics/timeline',
        workspace: 'Timeline',
      },
    ],
  },
  '/storage': {
    title: 'Storage',
    secondaryButtons: [
      {
        id: 'github-storage',
        label: 'External Storage',
        path: '/storage/github',
        workspace: 'GithubStorage',
      },
      {
        id: 'time-travel',
        label: 'Time Travel',
        path: '/storage/history',
        workspace: 'TimeTravel',
      },
    ],
  },
};

export const getWorkspaceConfig = (pathname) => {
  for (const [basePath, config] of Object.entries(workspaceMappings)) {
    if (pathname.startsWith(basePath)) {
      return config;
    }
  }
  return null;
};

export const getCurrentSecondaryButton = (pathname) => {
  const config = getWorkspaceConfig(pathname);
  if (config) {
    return config.secondaryButtons.find((button) => pathname === button.path);
  }
  return null;
};
